import { createApp, ref } from 'vue'
import Modal from '@/components/Modal/index.vue'

const useModal = (props, slots) => {
  const isOpen = ref(false)
  const app = ref();


  let DialogDom

  const close = () => {
    isOpen.value = false
    app.value.unmount()
    document.body.removeChild(DialogDom)
    app.value = null;
  }

  const confirm = () => {
    return new Promise((resolve, reject) => {
      const closeHandle = () => {
        reject(false);
        close();
      }
      const confirmHandle =  () => {resolve(true);close();}
      isOpen.value = true
      app.value = createApp(() => (<Modal {...(props || {})}  isModal={isOpen.value} onClose={closeHandle} onSelect={confirmHandle} v-slots={slots || {}} />))
      DialogDom = document.createElement('div')
      document.body.appendChild(DialogDom)
      app.value.mount(DialogDom)
    })
  }



  return { confirm, close }
}

export default useModal
